"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;

var React = _interopRequireWildcard(require("react"));

var _Router = _interopRequireDefault(require("./Router"));

var _Documentation = _interopRequireDefault(require("./Documentation"));

var _Markdown = _interopRequireDefault(require("./Markdown"));

var _Layout = _interopRequireDefault(require("./Layout"));

var _Sidebar = _interopRequireDefault(require("./Sidebar"));

var _Content = _interopRequireDefault(require("./Content"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const buildRoutes = (data, github, logo) => {
  const items = data.filter(item => item.type !== 'separator');
  return items.map(item => {
    let render;

    switch (item.type) {
      case 'md':
        {
          const source = item.data;

          render = props => React.createElement(_Layout.default, null, React.createElement(_Sidebar.default, {
            path: props.path,
            data: data
          }), React.createElement(_Content.default, {
            logo: logo
          }, React.createElement(_Markdown.default, {
            source: source
          })));
        }
        break;

      case 'component':
        {
          const info = item.data;

          render = props => React.createElement(_Layout.default, null, React.createElement(_Sidebar.default, {
            path: props.path,
            data: data
          }), React.createElement(_Documentation.default, {
            name: item.title,
            info: info,
            github: github,
            logo: logo,
            filepath: item.filepath
          }));
        }
        break;

      case 'custom':
        {
          const CustomComponent = item.data;

          render = props => React.createElement(_Layout.default, null, React.createElement(_Sidebar.default, {
            path: props.path,
            data: data
          }), React.createElement(CustomComponent, null));
        }
        break;

      default:
        throw new Error(`Unknown type ${item.type}`);
    }

    return _objectSpread({}, item, {
      /* $FlowFixMe */
      render
    });
  });
};

function App({
  path,
  data,
  github,
  logo,
  title
}) {
  const routes = buildRoutes(data, github, logo);
  return React.createElement(_Router.default, {
    path: path,
    routes: routes,
    title: title
  });
}
//# sourceMappingURL=App.js.map